import DatabaseModel from './DatabaseModel.js';
import CacheService from './Cache.js';
import Documento from './Documento.js';
import Framework7 from 'framework7/framework7-lite.esm.bundle.js';

var AiAgentDocuments = Object.create(DatabaseModel);

AiAgentDocuments.model = 'ai/agent/documents';
AiAgentDocuments.modelFront = 'agenteia/documentos';

AiAgentDocuments.searchCatalog = function(params = {}, forceReload = true) {
    const self = this;
    const queryParams = {
        currentPage: (params.page || 1) - 1,
        perPage: params.limit || 500,
        sortBy: params.order || 'title',
        sortDesc: params.orderDir == 'DESC'
    };
    const serialized = Framework7.utils.serializeObject(queryParams);
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/search?' + serialized,
        method: 'POST',
        data: params.filter || {}
    }, !forceReload);
};

AiAgentDocuments.get = function(params, forceReload) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + params.itemId,
        method: 'GET',
        data: {}
    }, !forceReload);
};

AiAgentDocuments.uploadAndIndex = function(file, data = {}) {
    const self = this;
    const formData = new FormData();
    formData.append('file', file);
    Object.keys(data).forEach((key) => {
        const value = data[key];
        if (value === undefined || value === null) {
            return;
        }
        if (Array.isArray(value)) {
            formData.append(key, value.join(','));
            return;
        }
        formData.append(key, value);
    });

    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_movilidad + self.prefix + self.model + '/upload-and-index',
            method: 'POST',
            crossDomain: true,
            dataType: 'json',
            data: formData
        }).then(function({ data }) {
            CacheService.clearCache(self.model);
            resolve(data.dto || data);
        }).catch(function({ xhr }) {
            try {
                reject(JSON.parse(xhr.response).error);
            } catch (e) {
                reject(xhr.response);
            }
        });
    });
};

AiAgentDocuments.updateDocument = function(versionId, payload = {}) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + versionId,
        method: 'PUT',
        data: payload
    }, false).then(function(res) {
        CacheService.clearCache(self.model);
        return res;
    });
};

/**
 * Relanza la indexación de un documento tal y como está.
 *
 * No pasa por updateDocument a propósito: aquel solo reindexa si el fichero ha cambiado, y aquí el
 * fichero es el mismo — lo que ha cambiado es el indexador o el modelo de embeddings.
 */
AiAgentDocuments.reindex = function(versionId) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + versionId + '/reindex',
        method: 'POST',
        data: {}
    }, false).then(function(res) {
        CacheService.clearCache(self.model);
        return res;
    });
};

AiAgentDocuments.cancelIndex = function(versionId) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + versionId + '/cancel',
        method: 'POST',
        data: {}
    }, false).then(function(res) {
        CacheService.clearCache(self.model);
        return res;
    });
};

AiAgentDocuments.deleteDocument = function(versionId, deletePhysicalFile = true) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + versionId + '/delete?deletePhysicalFile=' + deletePhysicalFile,
        method: 'POST',
        data: {}
    }, false).then(function(res) {
        CacheService.clearCache(self.model);
        return res;
    });
};

AiAgentDocuments.getDownloadUrl = function(item) {
    if (!item) {
        return '';
    }

    const sourceDocumento = item.documento || {};
    const path = sourceDocumento.path || item.path || '';
    const fileName = sourceDocumento.filename || item.filename || '';
    const extension = sourceDocumento.extension || item.extension || (fileName && fileName.indexOf('.') > -1 ? fileName.split('.').pop() : '');
    const nombre = sourceDocumento.nombre
        || (fileName
            ? (fileName.lastIndexOf('.') > -1 ? fileName.substring(0, fileName.lastIndexOf('.')) : fileName)
            : '');

    const documento = {
        path,
        nombre,
        extension,
        tipo: sourceDocumento.tipo || item.tipo || '',
        comentario: sourceDocumento.comentario || item.descripcion || '',
        camposPersonalizados: Object.assign({}, sourceDocumento.camposPersonalizados || {})
    };

    if (!documento.nombre && fileName) {
        const lastDot = fileName.lastIndexOf('.');
        documento.nombre = lastDot > -1 ? fileName.substring(0, lastDot) : fileName;
    }

    if (!documento.extension) {
        if (fileName && fileName.indexOf('.') > -1) {
            documento.extension = fileName.split('.').pop();
        } else if (item?.extension) {
            documento.extension = item.extension;
        }
    }

    if (!documento.tipo && item?.tipo) {
        documento.tipo = item.tipo;
    }

    if (!documento.comentario && item?.descripcion) {
        documento.comentario = item.descripcion;
    }

    if (item?.document_id) {
        documento.camposPersonalizados.document_id = item.document_id;
    }
    if (item?.version_id) {
        documento.camposPersonalizados.version_id = item.version_id;
    }
    if (item?.materia) {
        documento.camposPersonalizados.materia = item.materia;
    }

    return Documento.getDocumentoPublicUrl(documento) + '&ignoreBasePath=true';
};

export default AiAgentDocuments;
